import React, {useEffect} from 'react';
import {Col, Row} from "react-bootstrap";
//import NewStundenAuftraggeber from "./NewStundenAuftraggeber";
import {getToken} from "../../Utils/Common";

function StundenAuftraggeber(props) {

    const [agData, setAGData] = React.useState(props.auftraggeberData);
    const [projectIDData, setprojectIDData] = React.useState([])


    useEffect(() => {
        setAGData(props.auftraggeberData);
        fetchAG().then(agData => {
            console.log(projectIDData)
            setprojectIDData(agData.data)
        })
    }, [agData]);

    async function fetchAG() {

        let apiBody = {
            "token": getToken(), "data": {
                "projectID": props.pID
            }
        }

        return await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/auftraggeberList", {
            method: 'POST', headers: {
                'Content-type': 'application/json',
            }, body: JSON.stringify(apiBody),
        })
            .then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
    }

    function getAuftraggeberTableBody(auftraggeberData) {
        return auftraggeberData?.map((item) => (<tr key={item.id}>
            <td>{"Herr"}</td>
            <td>{item.firstName}</td>
            <td>{item.lastName}</td>

        </tr>))
    }



    return (<>
        {/*<NewStundenAuftraggeber
            projectID={props.pID}
            originState={props.originState}
            auftraggeberReportData={props.auftraggeberData}
            setAuftraggeberReportData={setAGData}
            projectIDData={projectIDData}
            setIsChange={props.setIsChange}
        />*/}
        <Col style={{paddingLeft:0}} sm={1}>
                        <label className="handwai-text-label-main">{'Auftraggeber'}</label>
                    </Col>
        <br/>
        <Row>
            <table className="table handwai-white-text"
            style={{marginLeft:15,marginRight:15}}>
                <thead>
                <tr>
                    <th scope="col">Anrede</th>
                    <th scope="col">Vorname</th>
                    <th scope="col">Nachname</th>
                </tr>
                </thead>
                <tbody>
                {getAuftraggeberTableBody(props.auftraggeberData)}
                </tbody>
            </table>
        </Row>
    </>);
}

export default StundenAuftraggeber;
